import * as React from 'react'
import { createStyles, Theme, WithStyles, withStyles, Typography, ExpansionPanel, ExpansionPanelSummary, ExpansionPanelDetails, Icon, Table, TableRow, TableCell, TableBody } from '@material-ui/core'
import { withI18n, WithI18n } from 'src/core/i18n/withI18n'
import { compose } from 'redux'
import { RootState } from 'src/core/redux/reducer'
import { connect } from 'react-redux'
import StatusFormSkill from 'src/page/Consumer/Enterprise/cards/StatusFormSkill'
import { formatDate } from 'src/core/i18n/date'
import { formAction } from 'src/core/redux/action/formAction'
import FormWithAnswer from 'src/shared/FormArkea/FormWithAnswer'
import PcDialog from 'src/shared/Dialog/PcDialog'
import autobind from 'autobind-decorator'
import Btn from 'src/shared/Btn/Btn'
import * as moment from 'moment'
import { refeshAfterChange } from 'src/core/redux/action/accountInfosAction'
import { isBtnEditActived } from 'src/shared/FormArkea/helpers'
import { withRouter, RouteComponentProps } from 'react-router'

const styles = (t: Theme) => createStyles({
  expansionPnl: {
    boxShadow: 'none',
    '&:before': {
      display: 'none'
    },
  },
  title: {
    textTransform: 'uppercase'
  },
  media: {
    margin: t.spacing.unit * 2,
    display: 'flex',
    justifyContent: 'flex-start'
  },
  mediaContent: {
    paddingLeft: t.spacing.unit * 2,
    display: 'flex',
    flexDirection: 'column'
  },
  info: {
    paddingLeft: '3px'
  },
  xsScroll: {
    [t.breakpoints.down('sm')]: {
      overflow: 'auto'
    },
  },
  cursorPointer: {
    cursor: 'pointer'
  },
  btn: {
    backgroundColor: '#039BE5'
  },
  flex: {
    display: 'flex',
    flexDirection: 'row',
    [t.breakpoints.down('md')]: {
      flexDirection: 'column',
    },
  },
  flexTypo: {
    display: 'inline-flex',
    [t.breakpoints.down('xs')]: {
      display: 'inline',
    },
  },
  mediaBtn: {
    marginTop: 'auto'
  },
  textCenter: {
    textAlign: 'center'
  },
  textBold: {
    fontWeight: 'bold'
  },
  marginVertical: {
    borderTop: '15px solid transparent',
    borderBottom: '15px solid transparent',
  }
});

const analyseQP = {
  qp_warning_oblig_titres_creance: ["1", "2"],
  qp_warning_structure_complexe: ["3", "4", "5", "6"],
  qp_warning_change_ferme: ["8", "9", "10", "11"],
  qp_warning_change_conditionnel: ["12", "13", "14", "15"],
  qp_warning_taux_ferme: ["17", "18", "19", "20"],
  qp_warning_taux_conditionnel: ["21", "22", "23", "24"]
}

const analyseQP_v2 = {
  qp_warning_oblig_titres_creance: ["2", "3"],
  qp_warning_structure_complexe: ["4", "5"],
  qp_warning_change_ferme: ["7", "8", "9", "10"],
  qp_warning_change_conditionnel: ["11", "12", "13", "14"],
  qp_warning_taux_ferme: ["16", "17", "18", "19"],
  qp_warning_taux_conditionnel: ["20", "21", "22", "23"]
}

const QPPlacement = ["qp_warning_oblig_titres_creance", "qp_warning_structure_complexe"]
const QPChange = ["qp_warning_change_ferme", "qp_warning_change_conditionnel"]
const QPDette = ["qp_warning_taux_ferme", "qp_warning_taux_conditionnel"]
const QP = [QPPlacement, QPChange, QPDette]
const PK = ["qp_level_placement", "qp_level_change", "qp_level_dette"]


interface IProps extends WithStyles<typeof styles>,
  WithI18n,
  RouteComponentProps<any>,
  ReturnType<typeof state2props>,
  ReturnType<typeof dispatch2props> {
  isFormShouldBeUpdate: boolean;
}

interface IStates {
  modalFormWithAnswerOpened: boolean;
  titleFormWithAnswer: string | null;
  visibleQuestions: string | string[];
}

class EnterpriseForms extends React.Component<IProps, IStates> {
  state = {
    modalFormWithAnswerOpened: false,
    titleFormWithAnswer: null,
    visibleQuestions: 'all'
  };

  questionPersonalRendering = () => {
    const { t, enterprise, classes, form } = this.props
    const notions = {
      advanced: t.EnterpriseDetail_statut_form_skill_advanced_lbl,
      informed: t.EnterpriseDetail_statut_form_skill_informed_lbl,
      basic: t.EnterpriseDetail_statut_form_skill_basic_lbl,
      non_disponible: t.EnterpriseDetail_statut_form_skill_non_disponible_lbl
    }
    return PK.map((ele, index) => (
      <TableBody className={`${index === 1 ? classes.marginVertical : ''}`}>
        <TableRow key={`analyse-qp-${index}`}>
          <TableCell>
            <Typography variant="body2" className={classes.textBold}>{t[ele]}</Typography>
          </TableCell>
          <TableCell className={classes.textCenter}>{notions[enterprise[ele]]}</TableCell>
          <TableCell></TableCell>
        </TableRow>
        {QP[index].map(lbl => (
          <TableRow key={`analyse-qp-${lbl}`}>
            <TableCell>{t[lbl]}</TableCell>
            <TableCell className={classes.textCenter}>{this.answerQuestionPersonalRendering(lbl)}</TableCell>
            <TableCell>
              <Icon
                style={{ cursor: 'pointer' }}
                onClick={
                  () => this.showAnswers(this.getAnalyseQPByVersion(form)[lbl], t[lbl])
                }
              >
                visibility
              </Icon>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    ))
  }

  getAnalyseQPByVersion = (form) => {
    if (form.tag === "qp_v2") return analyseQP_v2
    return analyseQP
  }

  answerQuestionPersonalRendering = (question: string) => {
    const { t, classes, enterprise } = this.props
    return enterprise[question] ? <StatusFormSkill status={enterprise[question]} /> : <span className={classes.info}>{t.not_available}</span>
  }


  componentDidMount() {
    const { enterprise, fetchForm } = this.props;
    fetchForm(enterprise.id, enterprise.qp_version)
  }

  render() {
    const { t, classes, context, enterprise, form, isFormShouldBeUpdate, connectedUser } = this.props
    const { visibleQuestions } = this.state
    return (
      <>
        <ExpansionPanel defaultExpanded={true} className={classes.expansionPnl}>
          <ExpansionPanelSummary expandIcon={<Icon>expand_more</Icon>}>
            <Typography variant="subtitle2" className={classes.title}>{t.EnterpriseDetail_form_questionnaire}</Typography>
          </ExpansionPanelSummary>
          <ExpansionPanelDetails className={classes.xsScroll}>
            <div>
              <div className={classes.media}>
                <Icon>timer</Icon>
                <div className={classes.mediaContent} >
                  <Typography variant="body2">
                    {t.EnterpriseDetail_form_next_update}
                    <span className={classes.info}>
                      {formatDate(new Date(this.getDateNextUpdateForm(enterprise.qp_last_updated_at)))}
                    </span>
                    {isFormShouldBeUpdate === true &&
                      <Typography variant="caption" color="error" style={{ fontWeight: 'bold' }}>
                        {t.EnterpriseDetail_form_alert_form_update}
                      </Typography>
                    }
                  </Typography>
                </div>
              </div>

              <div className={classes.flex}>
                <div className={classes.media}>
                  <Icon>{enterprise.qp_status === 'pending' ? 'warning' : 'assignment'}</Icon>
                  <div className={classes.mediaContent}>
                    <div>
                      <Typography variant="body2">{t.status}:</Typography>
                      <Typography variant="body2" gutterBottom>
                        <span className={classes.info} style={{ fontWeight: 'bold' }}>
                          {this.qpStatus()}
                        </span>
                      </Typography>
                    </div>
                    <div className={classes.mediaBtn}>
                      <Btn
                        color='primary'
                        onClick={this.openFormToAnswer}
                        icon='edit'
                        variant='contained'
                        className={classes.btn}
                        disabled={!isBtnEditActived(context, enterprise, connectedUser)}
                      >
                        {t.edit}
                      </Btn>
                    </div>
                  </div>
                </div>

                <div className={`${classes.media} ${classes.cursorPointer}`}>
                  <Icon>visibility</Icon>
                  <div className={classes.mediaContent}>
                    <div>
                      <Typography variant="body2">{t.EnterpriseDetail_form_answer_saved}</Typography>
                      {enterprise.qp_last_updated_by !== undefined &&
                        <Typography variant="caption" className={classes.flexTypo}>
                          {t.EnterpriseDetail_form_edit_by}
                          <span className={classes.info}>
                            {enterprise.qp_last_updated_by &&
                              enterprise.qp_last_updated_by
                            }
                            {enterprise.qp_last_updated_by === undefined &&
                              t.not_available
                            }
                          </span>
                          <span className={classes.info}>le</span>
                          <span className={classes.info}>
                            {enterprise.qp_last_updated_at &&
                              formatDate(new Date(enterprise.qp_last_updated_at))
                            }
                            {enterprise.qp_last_updated_at === undefined &&
                              t.not_available
                            }
                          </span>
                        </Typography>
                      }
                      {enterprise.qp_last_updated_by === undefined &&
                        <Typography variant="caption" className={classes.flexTypo}>
                          <span>{t.EnterpriseDetail_form_last_response_saved}</span>
                          <span className={classes.info}>par {t.arkea} le</span>
                          <span className={classes.info}>
                            {enterprise.qp_last_updated_at &&
                              formatDate(new Date(enterprise.qp_last_updated_at))
                            }
                            {enterprise.qp_last_updated_at === undefined &&
                              t.not_available
                            }
                          </span>
                        </Typography>
                      }
                    </div>
                    <div className={classes.mediaBtn}>
                      <Btn
                        color='primary'
                        variant='contained'
                        className={classes.btn}
                        onClick={() => this.showAnswers("all", null)}
                      >
                        {t.EnterpriseDetail_form_see_answer}
                      </Btn>
                    </div>
                  </div>
                </div>

                <div className={classes.media}>
                  <Icon>picture_as_pdf</Icon>
                  <div className={classes.mediaContent} >
                    <div>
                      <Typography variant="body2">{t.EnterpriseDetail_form_pdf_signed}</Typography>
                      <Typography variant="caption" className={classes.flexTypo}>
                        {enterprise.qp_last_signed_by &&
                          <>
                            <span>{t.EnterpriseDetail_signed_by}</span>
                            <span className={classes.info}>{enterprise.qp_last_signed_by}</span>
                          </>
                        }
                      </Typography>
                    </div>
                    <div className={classes.mediaBtn}>
                      <Btn
                        color='primary'
                        variant='contained'
                        onClick={this.downloadDocumentSigned}
                        className={classes.btn}
                        disabled={enterprise.qp_doc_url === undefined}
                      >
                        {t.download}
                      </Btn>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ExpansionPanelDetails>
        </ExpansionPanel>

        <ExpansionPanel defaultExpanded={true} className={classes.expansionPnl}>
          <ExpansionPanelSummary expandIcon={<Icon>expand_more</Icon>}>
            <Typography variant="subtitle2" className={classes.title}>{t.EnterpriseDetail_form_analyse_questionnaire}</Typography>
          </ExpansionPanelSummary>
          <ExpansionPanelDetails className={classes.xsScroll}>
            <div>
              <Table>
                {this.questionPersonalRendering()}
              </Table>
              <br />
              <Typography variant="caption" gutterBottom>
                {t.EnterpriseDetail_form_last_updated}
                {enterprise.qp_last_updated_at ?
                  (<span className={classes.info}>{formatDate(new Date(enterprise.qp_last_updated_at))}</span>) :
                  (<span className={classes.info}>{t.not_available}</span>)
                }
              </Typography>
            </div>
          </ExpansionPanelDetails>
        </ExpansionPanel>

        <PcDialog
          open={this.state.modalFormWithAnswerOpened}
          maxWidth="md"
          fullWidth={true}
        >
          <FormWithAnswer form={form} visibleQuestions={visibleQuestions} close={this.toogleModalFormWithAnswer} />
        </PcDialog>
      </>
    )
  }

  @autobind
  private getDateNextUpdateForm(qpDate: string) {
    return moment(qpDate).add(2, 'years').format()
  }

  @autobind
  private toogleModalFormWithAnswer() {
    this.setState({ modalFormWithAnswerOpened: !this.state.modalFormWithAnswerOpened })
  };

  @autobind
  private openFormToAnswer() {
    const { enterprise } = this.props
    this.props.history.push(`/ptf/enterprise/${enterprise.id}/form`)
  };

  @autobind
  private downloadDocumentSigned() {
    const { enterprise } = this.props
    window.open(enterprise.qp_doc_url, '_blank')
  };

  @autobind
  private showAnswers(questions: string | string[], title: string) {
    this.setState({ visibleQuestions: questions, titleFormWithAnswer: title })
    setTimeout(() => {
      this.toogleModalFormWithAnswer()
    }, 500)
  }

  @autobind
  private qpStatus() {
    const { enterprise, t } = this.props
    let status = ""
    if (enterprise.qp_status) {
      if (enterprise.qp_status === 'pending') {
        status = t.EnterpriseDetail_form_status_pending
      }
      if (enterprise.qp_status === 'validated') {
        if(moment().diff(enterprise.qp_last_updated_at, "hours") > 24) {
            status = t.EnterpriseDetail_form_status_valid
            } else {
              if (enterprise.qp_daily_update >= 2) {
                status = t.EnterpriseDetail_form_status_daily_limit_exceeded
              }
            }
          status = t.EnterpriseDetail_form_status_valid
        }
      }
    return status
  }
}

const state2props = (state: RootState) => ({
  enterprise: state.accountInfo.enterpriseSelected,
  connectedUser: state.accountInfo.connectedUser,
  form: state.formAnswer.form,
  context: state.accountInfo.context,
});

const dispatch2props = (dispatch: any, ownProps: any) => ({
  fetchForm: (id: string, version) => dispatch(formAction.fetchForm(id, version)),
  saveAnswer: (id: string, version: number, answers: any) => dispatch(formAction.saveAnswer(id, version, answers)),
  refeshAfterSave: () => dispatch(refeshAfterChange()),
 });

export default compose(
  withI18n,
  withRouter,
  connect(state2props, dispatch2props),
  withStyles(styles)
)(EnterpriseForms)



// WEBPACK FOOTER //
// ./src/page/Consumer/Enterprise/cards/EnterpriseForm.tsx